export interface IAddress {
    addressOne: string;
    addressTwo?: string;
    city: string;
    state: string;
    zip: string;
}

export const countValidationErrors = (vuelidateObject: Record<string, any>): string => {
    let errorCount = 0;

    Object.keys(vuelidateObject).forEach((key: string) => {
        const field = vuelidateObject[key] as { $invalid?: boolean; $dirty?: boolean };
        if (typeof field === 'object' && field?.$invalid && field?.$dirty) {
            errorCount++;
        }
    });

    return numberToWords(errorCount);
};

const numberToWords = (num: number): string => {
    const words: string[] = [
        'zero',
        'one',
        'two',
        'three',
        'four',
        'five',
        'six',
        'seven',
        'eight',
        'nine',
        'ten',
        'eleven',
        'twelve',
        'thirteen',
        'fourteen',
        'fifteen',
        'sixteen',
        'seventeen',
        'eighteen',
        'nineteen',
        'twenty',
    ];

    return num <= 20 ? words[num] : num.toString();
};

export const getErrorMessageText = (vuelidateObject: Record<string, any>): string => {
    const errorCount: number | string = countValidationErrors(vuelidateObject);
    if (errorCount === 'zero') return '';

    return errorCount === 'one' ? `There is ${errorCount} error.` : `There are ${errorCount} errors`;
};

export const showErrorCount = (vuelidateObject: Record<string, any>): boolean => {
    const errors: string = getErrorMessageText(vuelidateObject);
    return errors !== '' && errors !== 'zero';
};

export const formatAddress = (address: IAddress): IAddress | {} => {
    if (!address.addressOne || !address.city || !address.state || !address.zip) {
        return {};
    }

    return address;
};

export const getGender = (value: number | string): string => {
    const gender = parseInt(value as string, 10);
    return gender === 1 ? 'Male' : gender === 2 ? 'Female' : gender === 0 ? 'Other/Prefer not to say':'';
};
